77<template>
  <div class="row">
    <div class="class col-lg-2 col-sm-12 col-md-2 pl-1">
      <img
        :src="applicant.Profile.AvatarHref || userImg"
        class="rounded-circle img-height"
      />
    </div>
    <div class="col-lg-7 col-sm-12 col-md-7 text-left mt-3 mt-lg-0">
      <div class="font-weight-bolder kova-text d-lg-flex justify-content-between">
        <h5 class="mb-0">{{ applicantName }}
          <img
            class="mb-1"
            style="height:22px;"
            src="@/assets/kovatek/correct.svg"
            alt=""
          />
        </h5>

        <div class="d-flex ml-lg-3 mr-lg-5">
            <img
              class="mr-1 mt-1 rating"
              height="15"
              src="@/assets/kovatek/best.svg"
              alt=""
            />
            <h5 class="font-weight-bolder ctrl-size-1 kova-green mb-0">
              {{ applicant.Profile.SkillScore }}
            </h5>
            <h5 class="ml-2 ctrl-size-2 kova-light mb-0">
              {{ applicant.Profile.Reviews }} reviews
            </h5>
        </div>
      </div>

      <p class="d-flex justify-content-between">
        <span class="font-italic">{{ applicantRole }}</span>
        <span class="ml-2 text-uppercase intermediate mr-lg-5">{{ applicantLevel }}</span>
      </p>

      <p class="text-size2 text-justify mt-2">
        {{ comment }}
        <template v-if="comment.length > 120">
          <span @click="seeMore = !seeMore" class="ml-1 ant-color pointer">{{ seeMore ? 'show less' : 'see more' }} </span>
        </template>
      </p>

      <div class="text-left d-flex flex-wrap">
        <span
          class="bg-skills px-3 py-2 mr-3 mb-3 rounded ctrl-size-2 pointer"
          v-for="skill in applicantSkills"
          :key="skill"
        >
          {{ skill }}
        </span>
        <span
          class="px-3 py-2 mr-3 mb-3 rounded ctrl-size-2 pointer d-none"
          style="background-color: #EFEFEF"
        >
          <b>+ more</b>
        </span>
      </div>
    </div>

    <div
      class="pl-4 pl-sm-5 pl-md-3 mt-3 mt-md-0 col-lg-3 col-sm-12 col-md-3 text-center text-lg-right float-text"
    >
      <h6 class="font-weight-bolder kova-light ctrl-size-3">
        Projects completed: {{ applicant.Profile.ProjectsCompleted }}
      </h6>
      <h6 class="font-weight-bolder kova-light ctrl-size-3">
        Team Work: 0
      </h6>

      <h5 class="font-weight-bolder kova-text mt-md-5 pt-md-5">
        ${{ formatAmount(applicant.TotalAmount) }}
      </h5>
      <!-- <h6>{{applicant.hours}} hours </h6> -->
      <!-- <span class="ml-2"><img class="mr-2" src="../assets/kovatek/best.svg" alt="" /><span class="font-weight-bolder ctrl-size-1">9.5</span><span class="ml-2 ctrl-size-2">56 reviews</span></span> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    applicant: Object,
  },
  data: () => ({
    seeMore: false,
  }),
  computed: {
    applicantName() {
      return this.applicant.Profile.Name || this.applicant.Profile.UserName || 'Kovatek Talent';
    },
    applicantRole() {
      const speciality = this.applicant.Profile.Speciality;
      if (!speciality) return '';
      return speciality?.split(' ').length > 1 && !speciality.includes('tack')
        ? speciality
        : `${speciality} Engineer`;
    },
    applicantLevel() {
      return this.levels.find((key) => key.id == this.applicant.Profile.WorkRate)?.level;
    },
    applicantSkills() {
      const {
        Speciality,
        OtherCoreTechstacks,
        CoreTechstack,
      } = this.applicant.Profile;

      if (CoreTechstack && CoreTechstack.includes(',')) {
        const core_techstack = (CoreTechstack || [])
          .split(',')
          .filter((key) => key.length);

        return Speciality
          ? [Speciality, ...core_techstack, ...OtherCoreTechstacks]
          : [];
      }

      return Speciality
        ? [Speciality, CoreTechstack, ...OtherCoreTechstacks]
        : [];
    },
    comment() {
      const comment = this.applicant.CoverLetter || (this.applicant.Profile.AboutMe).replace(/<\/?[^>]+(>|$)/g, "") || ``
      if(!this.seeMore) return comment.slice(0, 120)
      return comment
    }
  }
};
</script>

<style scoped>
  .bg-skills {
    background-color: #4bb38e;
    color: #fff;
  }

  .img-height {
    width: 90px;
    height: 90px;
  }
</style>